<script setup lang="ts">
import {computed} from 'vue'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'
import {useGlobalStore} from '../../stores/global'

type Emit = {
  toggleMenu: []
}

interface Props {
  light?: boolean
}

const globalStore = useGlobalStore()
const isNewUiEnabled = useNewUiEnabled()
defineEmits<Emit>()
const props = withDefaults(defineProps<Props>(), {
  light: true,
})

const profileClasses = computed(() => ({
  'text-new-secondary-500 hover:text-new-secondary-600': isNewUiEnabled.value && props.light,
  'text-new-tertiary-500 hover:text-new-tertiary-100': isNewUiEnabled.value && !props.light,
  'text-brandmain hover:text-branddark': !isNewUiEnabled.value && props.light,
  'text-brandlightdarker hover:text-white': !isNewUiEnabled.value && !props.light,
  'cursor-pointer': isNewUiEnabled.value,
}))

const logoutClasses = computed(() => ({
  'text-new-red-500 hover:text-new-red-600': isNewUiEnabled.value,
  'text-lightred hover:text-branddark': !isNewUiEnabled.value && props.light,
  'text-lightred hover:text-white': !isNewUiEnabled.value && !props.light,
}))

function onClickLogout() {
  window.location.replace('/api/auth/logout')
}
</script>

<template>
  <div class="flex flex-col gap-y-4">
    <div v-show="globalStore.hasAuthority('VIEWER') || globalStore.hasAuthority('TESTING')">
      <router-link :class="profileClasses" to="/settings/user" @click="$emit('toggleMenu')">
        <i aria-hidden="true" class="fa fa-user pr-2"></i>
        <span class="uppercase">{{ $t('accountDropdown.profile') }}</span>
      </router-link>
    </div>

    <div>
      <button :class="logoutClasses" @click="onClickLogout">
        <i aria-hidden="true" class="fa fa-sign-out-alt pr-2"></i>
        <span class="uppercase">{{ $t('logout') }}</span>
      </button>
    </div>
  </div>
</template>
